function MyProfile() {
  return <div>My profile</div>;
}

export default MyProfile;
